class customBundle extends HTMLElement {
  constructor() {
    super();
    this.bundle_click = this.querySelector(".bundle_click").addEventListener("click", e => {
      e.preventDefault();
      this.togglePopupopen();
    });
    this.buttonclose = this.querySelector(".button--close").addEventListener("click", e => {
      e.preventDefault();      
      this.togglePopupclose();
    });

    this.form = this.querySelector("form").addEventListener("submit", this.onSubmitHandler.bind(this));
    this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    this.submitButton = this.querySelector('[type="submit"]');
    this.submitButtonText = this.submitButton.querySelector("span");
    if (document.querySelector("cart-drawer")) {
      this.submitButton.setAttribute("aria-haspopup", "dialog");
    }
    this.hideErrors = this.dataset.hideErrors === "true";
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      this.changeVariant(event);
    });
  }

  togglePopupopen() {
    document.querySelector("html").classList.add('popup_open');
    this.querySelector(".bundle__blocks").classList.remove('hidden');
  }

  togglePopupclose() {
    document.querySelector("html").classList.remove('popup_open');
    this.querySelector(".bundle__blocks").classList.add('hidden');
  }

  changeVariant(event) {
    if (event.target.name === 'addon1') {
      this.querySelector('.bundle_image_layer2').src = event.target.dataset.image;
      this.querySelector('.bundle_image_layer2').style.display = 'block';
    }
    if (event.target.name === 'addon2') {
      // this.querySelector('.bundle_image_layer3').src = event.target.dataset.image;
    }
  }

  onSubmitHandler(evt) {
    evt.preventDefault();

    this.submitButton.setAttribute("aria-disabled", true);
    this.submitButton.classList.add("loading");
    this.submitButton.querySelector(".loading__spinner").classList.remove("hidden");
    const config = fetchConfig('javascript');
    config.headers['Content-Type'] = "application/json";

    let data = {};
    const items = [];
    console.log(this,'thisthisthis',this.querySelector('[name="id"]'));
    items.push({
      "id": this.querySelector('[name="id"]').value,
      "quantity": 1
    });

    // Add all selected addon1 items
    const addon1Elements = this.querySelectorAll('[name="addon1"]');    
    addon1Elements.forEach(addon => {
      if (addon.checked) {
        console.log(addon,'addon1Elementsaddon1Elements');
        items.push({
          "id": addon.value,
          "quantity": 1
        });
      }
    });
  
    // Add all selected addon2 items
    const addon2Elements = this.querySelectorAll('[name="addon2"]');
    addon2Elements.forEach(addon => {
      if (addon.checked) {
         console.log(addon,'addon1Elementsaddon1Elements 22222222');
        items.push({
          "id": addon.value,
          "quantity": 1
        });
      }
    });
    
    data['items'] = items;

    if (this.cart) {
      data['sections'] = this.cart.getSectionsToRender().map(section => section.section);
      data['sections_url'] = window.location.pathname;
      this.cart.setActiveElement(document.activeElement);
    }
    console.log(data,'datadata');
    const body = JSON.stringify(data);
    fetch(`${routes.cart_add_url}`, { ...config, body })
      .then(response => response.json())
      .then(response => {
        if (response.status) {
          const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
          if (!soldOutMessage) return;
          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButtonText.classList.add("hidden");
          soldOutMessage.classList.remove("hidden");
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        this.error = false;
        this.cart.renderContents(response);
      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => {
        this.togglePopupclose();
        this.submitButton.classList.remove("loading");
        if (this.cart && this.cart.classList.contains("is-empty"))
          this.cart.classList.remove("is-empty");
        if (!this.error)
          this.submitButton.removeAttribute("aria-disabled");
        this.submitButton.querySelector(".loading__spinner").classList.add("hidden");
      });
  }
}

customElements.define("custom-bundle", customBundle);

if (!customElements.get('bundle-product-slider')) {
  class CardProductSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions =
        JSON.parse(this.getAttribute('data-swiper-options')) || {};

      this.sliderWrapper = this.querySelector('.swiper-wrapper');
      this.requiresFetch = this.hasAttribute('data-url');
      this.parent = this.closest('[data-section-id]');
      this.sliderOptions = {
        a11y: false,
        threshold: 3,
        spaceBetween: swiperOptions.spaceBetweenMobile || 2,
        slidesPerView: swiperOptions.slidesPerViewMobile || 'auto',
        resistanceRatio: 0.72,
      };
    }

    connectedCallback() {
      if (this.requiresFetch) {
        this.fetchItems();
        return;
      }
      this.initSlider();
    }

    fetchItems() {
      if (!this.parent) throw new Error('Parent is missing');
      fetch(this.getAttribute('data-url'))
        .then(response => response.text())
        .then(text => {
          const html = new DOMParser().parseFromString(
            text,
            'text/html'
          );
          const wrapper = html.querySelector('.swiper-wrapper');

          if (wrapper && wrapper.innerHTML.trim().length) {
            this.querySelector('.swiper-wrapper').innerHTML =
              wrapper.innerHTML;
            this.parent.classList.remove('hidden');
            this.initSlider();
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    initSlider(slider = this) {
      this.slider = new Swiper(slider, this.sliderOptions);

      this.slider.wrapperEl.setAttribute('aria-live', 'polite');
      this.slider.wrapperEl.id = `swiper-wrapper-${this.dataset.sectionId}`;
      this.slider.slides.forEach((slide, i) => {
        slide.setAttribute('role', 'group');
        slide.setAttribute(
          'aria-label',
          `${i + 1} / ${this.slider.slides.length}`
        );
        slide.dataset.index = i;
      });

      if (this.swiperOptions?.navigation) {
        const sliderButtons = [
          this.slider.navigation.prevEl,
          this.slider.navigation.nextEl
        ];

        sliderButtons.forEach((button, i) => {
          let type = 'Previous';

          if (i === 1) {
            type = 'Next';
          }

          button.setAttribute('aria-label', `${type} slide`);
          button.setAttribute(
            'aria-controls',
            this.slider.wrapperEl.id
          );
        });
      }

      this.slider.wrapperEl.addEventListener('focusin', e => {
        this.slider.el.scrollLeft = 0;

        const slide = e.target.closest('.swiper-slide');
        const slideIndex = +slide.dataset.index;
        const isFirstSlide = slideIndex === 0;
        const isLastSlide =
          slideIndex === this.slider.slides.length - 1;

        if (isFirstSlide || isLastSlide) {
          this.slider.slideTo(slideIndex, 0);

          return;
        }

        const slideRect = slide.getBoundingClientRect();
        const wrapperWidth = this.slider.wrapperEl.clientWidth;
        // prettier-ignore
        const slideLeft = slideRect.x + slideRect.width - ((document.body.clientWidth - wrapperWidth) / 2);
        const isSlideVisible =
          slideLeft <= wrapperWidth && slideLeft >= slideRect.width;

        if (isSlideVisible) {
          return;
        }
      });

      const swiperOptions =
        JSON.parse(this.getAttribute('data-swiper-options')) || {};
      /** stop / start autoplay on hover if quick cart is not open */
      this.slider.wrapperEl.addEventListener('mouseenter', () =>
        this.slider.autoplay.stop()
      );
      this.slider.wrapperEl.addEventListener('mouseleave', () => {
        if (!this.classList.contains('product--open-on-quick-cart')) {
          this.slider.autoplay.start();
        }
        if (swiperOptions.autoplay === false) {
          this.slider.autoplay.stop();
        }
      });
    }
  }

  customElements.define('bundle-product-slider', CardProductSlider);
}

const bundleFooter         = document.querySelector('.bundle-footer');
const mainProductPrice     = parseFloat(bundleFooter.dataset.mainProductPrice)  / 100;  
const mainProductCompPrice = parseFloat(bundleFooter.dataset.mainProductCompprice) / 100; 
const moneyFormat          = bundleFooter.dataset.moneyFormat;

const totalPriceEl = bundleFooter.querySelector('.total_price');
const discountEl   = bundleFooter.querySelector('.dis_bundle');

function updateTotalPrice() {
  const selectedAddon1 = document.querySelector('input[name="addon1"]:checked');
  const selectedAddon2 = document.querySelectorAll('input[name="addon2"]:checked'); 

  let addonPrice    = 0;  
  let addonDiscount = 0; 


  if (selectedAddon1) {
    const price = parseFloat(selectedAddon1.dataset.price) / 100;
    addonPrice    += price;
    addonDiscount += price * 0.85; 
  }


  selectedAddon2.forEach(el => {
    const price = parseFloat(el.dataset.price) / 100;
    addonPrice    += price;
    addonDiscount += price * 0.85;
  });


  const compPrice     = mainProductCompPrice + addonPrice;
  const discountPrice = mainProductPrice     + addonDiscount;
  const hasAddons     = addonPrice > 0;
   document.body.querySelector('.dis_bundle').textContent = formatPrice(moneyFormat, hasAddons ? discountPrice
                                                              : mainProductPrice);

  // Strikethrough compare‑at (only show when higher)
  if ((hasAddons && compPrice > discountPrice) ||
      (!hasAddons && mainProductCompPrice > mainProductPrice)) {
    document.body.querySelector('.total_price').textContent = formatPrice(moneyFormat,
                                           hasAddons ? compPrice
                                                     : mainProductCompPrice);
  } else {
    totalPriceEl.textContent = '';
  }
}

updateTotalPrice();

document.querySelectorAll('.add_on input[type="radio"], .add_on input[type="checkbox"]').forEach(input => input.addEventListener('change', updateTotalPrice));

  
document.body.addEventListener('change', function (e) {
  if (e.target.name === 'addon1' || e.target.name === 'addon2') {
    updateTotalPrice();
  }
});

// updateTotalPrice();


const variantOptionsContainer = document.querySelector('.bundle__main .product__variant-options');
if (variantOptionsContainer) {
  // variantOptionsContainer.addEventListener('change', (event) => {
  //   if (event.target.tagName === 'INPUT') {
  //     handleVariantChange(event);
  //   }
  // });
  document.body.addEventListener('change', (event) => {
  if (event.target.tagName === 'INPUT') {
    handleVariantChange(event);
  }
});
}

function handleVariantChange(event) {
  if (event.target.type === 'radio' && event.target.classList.contains('variant-option__input') && event.target.closest('.bundle__main')) {
    console.log('innnnnnnnnnnnnn');
    // Find the closest container for THIS set of radios
    const container = event.target.closest('.variant-options-container') || document;

    // Remove active class & checked from all radios in this container
    container.querySelectorAll('.bundle__main input[type="radio"]').forEach((input) => {
      input.removeAttribute('checked');
      const label = container.querySelector(`label[for="${input.id}"]`);
      if (label) label.classList.remove('active');
    });

    // Update selected text
    const checkedValue = event.target.value;
    const selectedValueSpan = document.querySelector('.bundle__main [data-selected-value]');
    if (selectedValueSpan) {
      selectedValueSpan.textContent = checkedValue;
    }

    // Update image and variant ID
    let bundleVariantUrl = null;
    let bundleVariantId = null;
    document.querySelectorAll('.bundle-metafiled-variant-image').forEach((image) => {
      if (image.dataset.title === checkedValue) {        
        bundleVariantUrl = image.dataset.bundleVariant;
        bundleVariantId = image.dataset.variantId;
      }
    });

    if (bundleVariantUrl) {
      const bundleImageLayer1 = document.querySelector('.bundle_image_layer1');
      if (bundleImageLayer1) {
        bundleImageLayer1.src = bundleVariantUrl;
      }
    }

    const bundleForm = document.getElementById('bundle-form');
    if (bundleForm) {
      const idInput = bundleForm.querySelector('input[name="id"]');      
      if (idInput) {
        idInput.value = bundleVariantId;
      }
    }
  }
}


document.body.addEventListener('click', function (e) {
  const target = e.target;

  // Only proceed if clicked element is an addon1 or addon2 input
  if (!(target.matches('input[name="addon1"], input[name="addon2"]'))) return;

  const name = target.getAttribute('name');
  const wasChecked = target.getAttribute('data-waschecked') === 'true';

  console.log('clickkkkkkkkkk', name);

  // ADDON1 (radio) logic
  if (name === 'addon1') {
    if (wasChecked) {
      target.checked = false;
      target.setAttribute('data-waschecked', 'false');
      document.querySelector('.bundle_image_layer2').setAttribute('src', '');
      document.querySelector('.bundle_image_layer2').style.display = 'none';
    } else {
      document.querySelectorAll('input[name="addon1"]').forEach((r) => {
        r.setAttribute('data-waschecked', 'false');
      });
      target.setAttribute('data-waschecked', 'true');
    }

  // ADDON2 (checkbox) logic
  } else if (name === 'addon2') {
    const checkedBoxes = document.querySelectorAll('input[name="addon2"]:checked');
    const checkedCount = checkedBoxes.length;

    if (!wasChecked && checkedCount > 2) {
      e.preventDefault();
      return;
    }

    if (wasChecked) {
      target.checked = false;
      target.setAttribute('data-waschecked', 'false');
    } else {
      target.setAttribute('data-waschecked', 'true');
    }

    // Rebuild selected images in order
    const addon2Images = Array.from(document.querySelectorAll('input[name="addon2"]'))
      .filter(input => input.checked)
      .map(input => input.getAttribute('data-image'));

    // Set images
    const layer3 = document.querySelector('.bundle_image_layer3');
    const layerAddon3 = document.querySelector('.bundle_image_layeraddon3');

    if (addon2Images[0]) {
      layer3.setAttribute('src', addon2Images[0]);
      layer3.style.display = 'block';
    } else {
      layer3.setAttribute('src', '');
      layer3.style.display = 'none';
    }

    if (addon2Images[1]) {
      layerAddon3.setAttribute('src', addon2Images[1]);
      layerAddon3.style.display = 'block';
    } else {
      layerAddon3.setAttribute('src', '');
      layerAddon3.style.display = 'none';
    }
  }

  // Clear discounted price if no add-ons selected
  if (
    document.querySelectorAll('.add_on input[type="radio"]:checked').length < 1 &&
    document.querySelectorAll('input[name="addon2"]:checked').length < 1
  ) {
    document.querySelector('.dis_bundle').innerHTML = '';
  }

  updateTotalPrice();
});



